









import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isArray } from 'lodash'

@Component
export default class FacetInputChoice extends Vue {
    @Prop({ required: true }) options!: [{ label: string, value: string|number }]
    @Prop() value!: string|number
    @Prop({ type: Boolean, default: false }) required!: boolean
    internalValue: string|number = null

    mounted(): void {
        this.onValueChanged()
    }

    @Watch('value')
    onValueChanged(): void {
        if (isArray(this.value) && this.value.length > 0) {
            this.internalValue = this.value[0]

        } else if (isArray(this.value)) {
            this.internalValue = null

        } else {
            this.internalValue = this.value
        }
    }

    selectOption(v: string|number): void {
        if (this.required && v === this.internalValue) {
            return
        }

        this.internalValue = (v === this.internalValue) ? null : v
        this.$emit('input', this.internalValue)
    }
}
